export default function Entry(height, width, x, y) {
  this.height   = height;
  this.width    = width;
  this.position = {x:x, y:y};
}
